module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "copyright"
    }
  }), _vm._v("© 2007 The Johns Hopkins University Press")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. Published 2007")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in the United States of America on acid-free paper")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Johns Hopkins Paperback edition, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("2  4   6  8  9  7  5  3  i")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("The Johns Hopkins University Press")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("2715 North Charles Street")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Baltimore, Maryland 21218–4363")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("www.press.jhu.edu")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('em', [_vm._v("The Library of Congress has catalogued the hardcover edition of this book asfollows:")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Ruggiero, Guido, 1944—")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Machiavelli in love : sex, self, and society in the Italian Renaissance / Guido Ruggiero.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN-13: 978-0-8018-8516-7 (hardcover : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN-10: 0-8018-8516-7 (hardcover : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("1 . Sex customs—Italy—History. 2. Renaissance—Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("3 . Sex—Social aspects—Italy—History. 4. Sex role—Italy—History.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("5 . Sex in literature. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("HQ18.I8I834 2006")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("306.70945 09024—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("2006015555")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("A catalog record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN 13: 978-0-8018-9835-8")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN 10: 0-8018-9835-8")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8422d616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0